import React, { useEffect } from "react";
import { trendingCategoryData } from "../../data/categories_data";
import Collection_category_filter from "../collectrions/collection_category_filter";
import CategoryItem from "./categoryItem";
import { useDispatch } from "react-redux";
import { updateTrendingCategoryItemData } from "../../redux/counterSlice";
import RenderGroup from "../campaigns/category_ui";
import { collectionDropdown2_data } from "../../data/dropdown";
import Tippy from "@tippyjs/react";
import Collection_dropdown2 from "../dropdown/collection_dropdown2";
import Collection_icons from "../dropdown/collection_icons";
import { useState } from "react";
import { campaignFilter } from "../../redux/apiSlice";
const top100Films = [
  { title: "The Shawshank Redemption", year: 1994 },
  { title: "The Godfather", year: 1972 },
  { title: "The Godfather: Part II", year: 1974 },
  { title: "The Dark Knight", year: 2008 },
  { title: "12 Angry Men", year: 1957 },
  { title: "Schindler's List", year: 1993 },
  { title: "Pulp Fiction", year: 1994 },
];

const FilterCategoryItem = ({ campaign, organization, description }) => {
  const dispatch = useDispatch();
  const [priceRange, setPriceRange] = useState({
    min: 0,
    max: 0,
    status: "All",
  });
  const [showFullDescription, setShowFullDescription] = useState(false);
  useEffect(() => {
    dispatch(updateTrendingCategoryItemData(trendingCategoryData.slice(0, 8)));
  }, [dispatch]);
  const data_status = [
    {
      id: 0,
      text: "All",
      image: "/images/avatars/collection_ava_1.png",
    },
    {
      id: 1,
      text: "Available",
      image: "/images/avatars/collection_ava_1.png",
    },
    {
      id: 2,
      text: "Sold",
      image: "/images/avatars/collection_ava_1.png",
    },
  ];

  useEffect(() => {
    dispatch(campaignFilter(priceRange));
  }, [priceRange, dispatch]);

  return (
    <div>
      {/* Overview Section */}
      {description && (
        <div className="px-6 mb-8">
          <h2 className="text-xl font-bold text-jacarta-700 dark:text-white mb-4">
            Overview
          </h2>
          <p className="text-jacarta-700 dark:text-jacarta-300 leading-relaxed">
            {showFullDescription
              ? description
              : `${description.substring(0, 150)}${description.length > 150 ? "..." : ""}`}
          </p>
          {description.length > 150 && (
            <button
              onClick={() => setShowFullDescription(!showFullDescription)}
              className="text-accent hover:text-accent-dark font-medium mt-2 text-sm uppercase tracking-wide"
            >
              {showFullDescription ? "READ LESS" : "READ MORE"}
            </button>
          )}
        </div>
      )}

      {/* Buy Impact Arts Section */}
      <div className="px-6 mb-6">
        <h2 className="text-xl font-bold text-jacarta-700 dark:text-white mb-4">
          Buy Impact Art to support this cause
        </h2>
      </div>

      {/* <!-- Filter --> */}
      {/* <Collection_category_filter /> */}

      {/* <RenderGroup top100Films={top100Films} /> */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8 px-6">
        <div>
          <label className="text-sm font-medium text-jacarta-700 dark:text-jacarta-300 mb-2 block">
            Filter Art
          </label>
          <div className="dropdown cursor-pointer w-full">
            <Collection_dropdown2
              setPriceRange={setPriceRange}
              priceRange={priceRange}
              data={data_status}
              collection={true}
            />
          </div>
        </div>

        <div>
          <label className="text-sm font-medium text-jacarta-700 dark:text-jacarta-300 mb-2 block">
            Min Price
          </label>
          <input
            type="number"
            className="w-full bg-white dark:bg-jacarta-700 border border-jacarta-100 dark:border-jacarta-600 rounded-lg py-3 px-4 text-jacarta-700 dark:text-white placeholder:text-jacarta-400 dark:placeholder:text-jacarta-500 focus:ring-accent focus:border-accent transition-all hover:border-accent"
            placeholder="$100"
            onChange={(e) =>
              setPriceRange({ ...priceRange, min: e.target.value })
            }
          />
        </div>

        <div>
          <label className="text-sm font-medium text-jacarta-700 dark:text-jacarta-300 mb-2 block">
            Max Price
          </label>
          <input
            type="number"
            className="w-full bg-white dark:bg-jacarta-700 border border-jacarta-100 dark:border-jacarta-600 rounded-lg py-3 px-4 text-jacarta-700 dark:text-white placeholder:text-jacarta-400 dark:placeholder:text-jacarta-500 focus:ring-accent focus:border-accent transition-all hover:border-accent"
            placeholder="$200"
            onChange={(e) =>
              setPriceRange({ ...priceRange, max: e.target.value })
            }
          />
        </div>
      </div>

      <CategoryItem />
    </div>
  );
};

export default FilterCategoryItem;
